export default {
  NOT_SCHEDULED: {
    Title: 'Not Scheduled',
    Color: '',
  },
  SCHEDULED: {
    Title: 'Scheduled',
    Color: '#67abde',
  },
  COMPLETED: {
    Title: 'Completed',
    Color: '#80d670',
  },
  NO_SHOW: {
    Title: 'No Show',
    Color: '#e05757',
  },
  RESCHEDULED: {
    Title: 'Rescheduled',
    Color: '#f2985d',
  },
  CANCELLED: {
    Title: 'Cancelled',
    Color: '#767676',
  },
};
